<template>
  <div style="text-align:center" :class="{ 'bc': blockCSS }">
    <div :class="{ 'pool-cloud': true, 'fm-set': true, 'reported': IsShow == null }">
      <div class="video" @mouseover="hoverVideo($event)" @mouseout="hideVideo($event)"
        @click="IsShow !== null ? $emit('ck') : ''">
        <video class="cloud-video-fm" preload="metadata" playsinline="" muted
          :poster="IsNullOrEmpty(poster) ? poster2 : poster" :src="`${url}${addT}`"></video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      addT:
        this.IsNullOrEmpty(this.poster) && this.IsNullOrEmpty(this.poster2)
          ? "#t=0.5"
          : "",
    };
  },
  props: {
    id: { Type: Number, require: true },
    url: { Type: String, require: true },
    poster: { Type: String, require: false },
    poster2: { Type: String, required: false },
    IsShow: { Type: Object },
    blockCSS: { Type: Object,default:false },
  },
  methods: {
    hoverVideo (event) {
      if (this.IsShow == null) return;
      if (event.target.play) {
        event.target.play();
      }
    },
    hideVideo (event) {
      if (this.IsShow == null) return;
      if (event.target.pause) {
        event.target.pause();
      }
    },
  },
};
</script>

<style scoped>
.cloud-video-fm {
  /* object-fit: fill; */
  width: 100%;
  background-color: black;
}
.bc{
   background-color: black;
}
@media (min-width: 1200px) {
  .cloud-video-fm {
    height: 169px !important;
  }
}

@media (min-width: 992px) and (max-width: 1199px) {
  .cloud-video-fm {
    height: 124px !important;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  .cloud-video-fm {
    height: 201px !important;
  }
}

@media (min-width: 576px) and (max-width: 767px) {
  .cloud-video-fm {
    height: 201px !important;
  }
}

@media (max-width: 575px) {
  .cloud-video-fm {
    height: 220px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Social/video.vue